// extracted by mini-css-extract-plugin
module.exports = {"header":"_gxXMcQqE","content":"_chUurmXz","badge":"_17LE93Os","paragraph":"_DhuQeLZl","footer":"_FgM3nmjY","continueButton":"_kkIqxvg_"};